import http from "@/utils/http.js"

export default{
    async list(){
        let api = "/tranChannel/list";
        let result = await http.get(api,{});
        return result.success && result.data;
    },
}